webpackJsonp([52],{

/***/ 1050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(1158);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd6567fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1229);
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd6567fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(511);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      Confirm_pass: '',
      header: {
        headers: {
          'Access-Token': this.$store.state.token
        }
      }
    };
  },

  methods: {
    getProfileUser: function getProfileUser() {
      var _this = this;

      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].userDetail(sessionStorage.Url, this.header, {}, function (result) {
        if (result.response === 'success') {
          sessionStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
          _this.$store.state.user = result.data;
          _this.Confirm_pass = '';
        } else {
          _this.alert_msg('warning', 'เข้าสู่ระบบ', result.message);
        }
        _this.$store.commit('Loading');
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.commit('Loading');
      });
    },
    validatePass: function validatePass() {
      if (this.$store.state.user.password !== '') {
        this.updateProfile();
      } else {
        this.alert_msg('warning', 'แจ้งเตือนระบบ', 'กรุณากรอกข้อมูลให้ครบถ้วน');
      }
    },
    updateProfile: function updateProfile() {
      var _this2 = this;

      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].userUpdate(sessionStorage.Url, this.header, this.$store.state.user, function (result) {
        if (result.response === 'success') {
          _this2.alert_msg('success', 'แก้ไขข้อมูล Profile', 'แก้ไขข้อมูลผู้ใช้งานเรียบร้อย');
          _this2.getProfileUser();
        } else {
          _this2.alert_msg('warning', 'แก้ไขข้อมูล Profile', result.message);
        }
        _this2.$store.commit('Loading');
      }, function (error) {
        _this2.alert_msg('error', 'แก้ไขข้อมูล Profile', 'ไม่สามารถแก้ไขข้อมูล Profile ได้ เนื่องจาก ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this2.$store.commit('Loading');
      });
    }
  },
  created: function created() {
    this.getProfileUser();
  }
});

/***/ }),

/***/ 1229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card card-primary card-outline"},[_c('div',{staticClass:"card-body box-profile"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"profile-user-img img-fluid img-circle",attrs:{"src":_vm.$store.state.user.url_image || '../../static/dist/img/avatar04.png',"alt":"User profile picture"}})]),_vm._v(" "),_c('h3',{staticClass:"profile-username text-center"},[_vm._v(_vm._s(_vm.$store.state.user.username))]),_vm._v(" "),_c('p',{staticClass:"text-muted text-center"},[_vm._v("ตำแหน่ง: "+_vm._s(_vm.$store.state.user.role_name))]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"card card-primary card-outline"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"tab-pane",attrs:{"id":"settings"}},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.validatePass($event)}}},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label",attrs:{"for":"inputName2"}},[_vm._v("Fullname")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$store.state.user.name),expression:"$store.state.user.name"}],staticClass:"form-control",attrs:{"type":"text","id":"Fullname","placeholder":"Fullname"},domProps:{"value":(_vm.$store.state.user.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$store.state.user, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label",attrs:{"for":"tel"}},[_vm._v("Telephone")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$store.state.user.telephone),expression:"$store.state.user.telephone"}],staticClass:"form-control",attrs:{"type":"text","id":"tel","placeholder":"telephone","maxlength":"15"},domProps:{"value":(_vm.$store.state.user.telephone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$store.state.user, "telephone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label",attrs:{"for":"New_Password"}},[_vm._v("New Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$store.state.user.password),expression:"$store.state.user.password"}],staticClass:"form-control",attrs:{"type":"password","id":"New_Password","placeholder":"New Password","autocomplete":"off"},domProps:{"value":(_vm.$store.state.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$store.state.user, "password", $event.target.value)}}})])]),_vm._v(" "),_vm._m(1)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success btn-block btn-sm"},[_c('i',{staticClass:"fas fa-image"}),_vm._v(" อัพโหลดโปร์ไฟล์")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"offset-sm-2 col-sm-10"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"submit"}},[_c('i',{staticClass:"far fa-save"}),_vm._v(" บันทึก")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/52.33a138ba751ed2b6d2a2.js